import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: "Space Grotesk"
  },
  palette: {
    primary: {
      main: '#e20613',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: '#cd5c5c',
    },
    background: {
      default: '#fff',
    },
  }
});

export default theme;
